// extracted by mini-css-extract-plugin
export default {"bodyFixed":"styles_bodyFixed__pIPx7"};